module.exports = "<sa-header></sa-header>\n\n\n<sa-navigation #navPanel></sa-navigation>\n\n\n<div id=\"main\" role=\"main\" #mainPanel>\n  <sa-layout-switcher></sa-layout-switcher>\n\n  <sa-ribbon #ribbon></sa-ribbon>\n\n  <router-outlet></router-outlet>\n</div>\n\n<sa-footer></sa-footer>\n\n<!-- <sa-shortcut></sa-shortcut> www-->\n"


//////////////////
// WEBPACK FOOTER
// C:/wxj/LicAuth/05開発/LicAuth.angularjs/src/app/shared/layout/app-layouts/main-layout.component.html
// module id = ../../../../../src/app/shared/layout/app-layouts/main-layout.component.html
// module chunks = main